import { IFeatureGroupBase } from '../../models/features';
import { IUserCategoryBase } from '../../models/userCategories';
import { IUserAssignmentBase, IUserBase } from '../../models/users';
import { IVentureBase } from '../../models/ventures';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IUpdatedUserCategory extends IUserCategoryBase {
  venture: IVentureBase;
}

interface IUserAssignment extends IUserAssignmentBase {
  featureGroup: IFeatureGroupBase;
  venture?: IVentureBase;
}

export interface IUpdatedUser extends IUserBase {
  categories: IUpdatedUserCategory[];
  userAssignments: IUserAssignment[];
}

export const enableUsersPaymentRegisterService = async (
  userId: string,
): Promise<IUpdatedUser> => {
  const { data } = await jhsfBookingsApi.post<IUpdatedUser>(
    `/users/${userId}/enable-payment`,
  );

  return data;
};
